import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { GATEWAY_LIST } from 'src/constants/queryKeys';

export const networkGetGatewayList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`Gateway/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGatewayList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [GATEWAY_LIST, payload, pageIndex],
    queryFn: () => networkGetGatewayList(payload, pageIndex, pageSize),
  });
}

export const networkGetGatewayInfo = async (id) => {
  const res = await axiosInstance.post(`Gateway/Info/${id}`);
  return res;
};

export const networkCreateGateway = async (data) => {
  const res = await axiosInstance.post('Gateway/Insert', data);
  return res;
};

export const networkUpdateGateway = async (id, data) => {
  const res = await axiosInstance.post(`Gateway/Update/${id}`, data);
  return res;
};

export const networkRemoveGateway = async (id) => {
  const res = await axiosInstance.post(`Gateway/Remove/${id}`);
  return res;
};

// -------------------------------------------------------------------------------

export const networkGetGatewayTypeList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GatewayType/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchGatewayTypeList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['gateway-type-list', pageIndex],
    queryFn: () => networkGetGatewayTypeList(pageIndex, pageSize),
  });
}

export const networkGetGatewayActiveTypeList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GatewayActiveType/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchGatewayActiveTypeList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['gateway-active-type-list', pageIndex],
    queryFn: () => networkGetGatewayActiveTypeList(pageIndex, pageSize),
  });
}

export const networkGetGatewayPriceTypeList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GatewayPriceType/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchGatewayPriceTypeList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['gateway-price-type-list', pageIndex],
    queryFn: () => networkGetGatewayPriceTypeList(pageIndex, pageSize),
  });
}

// -------------------------------------------------------------------------------

export const networkGetGatewayLogList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GatewayLog/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchGatewayLogList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['gateway-log-list', pageIndex],
    queryFn: () => networkGetGatewayLogList(pageIndex, pageSize),
  });
}

export const networkGetGatewayLogInfo = async (id) => {
  const res = await axiosInstance.post(`GatewayLog/Info/${id}`);
  return res;
};

export function useFetchGatewayLogInfo(id) {
  return useQuery({
    queryKey: ['gateway-log-info', id],
    queryFn: () => networkGetGatewayLogInfo(id),
  });
}

// -------------------------------------------------------------------------------

export const networkGetGatewayRefrenceKeyList = async (pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GatewayRefrenceKey/List/${pageIndex}/${pageSize}`);
  return res;
};

export function useFetchGatewayRefrenceKeyList(pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['gateway-refrencekey-list', pageIndex],
    queryFn: () => networkGetGatewayRefrenceKeyList(pageIndex, pageSize),
  });
}

export const networkGetGatewayRefrenceKeyInfo = async (id) => {
  const res = await axiosInstance.post(`GatewayRefrenceKey/Info/${id}`);
  return res;
};

export function useFetchGatewayRefrenceKeyInfo(id) {
  return useQuery({
    queryKey: ['gateway-refrencekey-info', id],
    queryFn: () => networkGetGatewayRefrenceKeyInfo(id),
  });
}

// -------------------------------------------------------------------------------

export const networkGetGatewayUserProfileList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`GatewayUserProfile/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchGatewayUserProfileList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['gateway-user-profile-list', payload, pageIndex],
    queryFn: () => networkGetGatewayUserProfileList(payload, pageIndex, pageSize),
  });
}

export const networkGetGatewayUserProfileInfo = async (id) => {
  const res = await axiosInstance.post(`GatewayUserProfile/Info/${id}`);
  return res;
};

export function useFetchGatewayUserProfileInfo(id) {
  return useQuery({
    queryKey: ['gateway-user-profile-info', id],
    queryFn: () => networkGetGatewayUserProfileInfo(id),
  });
}
